import { create } from 'zustand';
import { WebSocketLogState, DebugLogEntry } from '@/features/debug/types/debug.types';

interface DebugStore {
  websocket: WebSocketLogState;
  logWebSocketEvent: (entry: DebugLogEntry) => void;
  updateLastMessageTime: () => void;
  resetLogs: () => void;
  currentPage: number;
  setPage: (page: number) => void;
  isPaused: boolean;
  togglePause: () => void;
}

export const useDebugStore = create<DebugStore>((set) => ({
  websocket: {
    createdAt: new Date().toISOString(),
    lastMessageAt: null,
    logs: [],
  },
  currentPage: 1,
  isPaused: false,
  logWebSocketEvent: (entry) =>
    set((state) => {
      if (state.isPaused) {
        return {};
      }
      const MAX_LOG_ENTRIES = 500;
      let newLogs = [entry, ...state.websocket.logs];
      if (newLogs.length > MAX_LOG_ENTRIES) {
        newLogs = newLogs.slice(0, MAX_LOG_ENTRIES); // Keep the newest 500 entries
      }
      return {
        websocket: {
          ...state.websocket,
          logs: newLogs,
        },
      };
    }),
  updateLastMessageTime: () =>
    set((state) => ({
      websocket: {
        ...state.websocket,
        lastMessageAt: new Date().toISOString(),
      },
    })),
  resetLogs: () =>
    set(() => ({
      websocket: {
        createdAt: new Date().toISOString(),
        lastMessageAt: null,
        logs: [],
      },
      currentPage: 1,
      isPaused: false,
    })),
  setPage: (page: number) => set({ currentPage: page }),
  togglePause: () => set((state) => ({ isPaused: !state.isPaused })),
})); 